import script from "./UserCardLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCardLocation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__